import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useLang } from "@/i18n";

/* Clocked vs billed hours per mechanic — where does time evaporate? */
export default function MechanicProductivity({ start, end }) {
  const { t } = useLang();
  const { data } = useQuery({ queryKey: ["rep-mech", start, end], queryFn: () => api.get(`/reports/mechanics?start=${start}&end=${end}`).then((r) => r.data), enabled: !!start && !!end });
  const rows = data?.mechanics || [];
  const eff = (v) => (v == null ? "—" : `${v}%`);
  const effCls = (v) => (v == null ? "text-muted-foreground" : v >= 85 ? "text-emerald-600" : v >= 60 ? "text-amber-600" : "text-rose-600");
  return (
    <Card className="p-6 border-border overflow-x-auto" data-testid="rp-productivity">
      <div className="flex items-baseline justify-between gap-3 mb-4 flex-wrap">
        <h3 className="font-display text-xl font-bold">{t("rpProductivity")}</h3>
        <p className="text-xs text-muted-foreground">{t("rpProductivityHint")}</p>
      </div>
      <Table>
        <TableHeader><TableRow>
          <TableHead>{t("mechanic")}</TableHead>
          <TableHead className="text-right">{t("rpCards")}</TableHead>
          <TableHead className="text-right">{t("rpClockedHours")}</TableHead>
          <TableHead className="text-right">{t("rpBilledHours")}</TableHead>
          <TableHead className="text-right">{t("rpEfficiency")}</TableHead>
          <TableHead>{t("rpTopTasks")}</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-6">{t("noData")}</TableCell></TableRow>}
          {rows.map((m) => (
            <TableRow key={m.name} data-testid={`rp-prod-${m.name}`}>
              <TableCell className="font-medium">{m.name}</TableCell>
              <TableCell className="text-right tabular-nums">{m.cards}</TableCell>
              <TableCell className="text-right tabular-nums">{m.clocked_hours}</TableCell>
              <TableCell className="text-right tabular-nums">{m.billed_hours}</TableCell>
              <TableCell className={`text-right font-mono font-bold tabular-nums ${effCls(m.efficiency)}`}>{eff(m.efficiency)}</TableCell>
              <TableCell className="text-xs text-muted-foreground">{m.top_tasks.map((x) => `${x.task} ${x.hours}u`).join(" · ")}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
